import Image, { ImageProps } from "next/image";
import { useEffect, useState, memo, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

interface Props extends ImageProps {
  forceUpdate?: boolean;
  isUser?: boolean;
  thumbnail?: string; 
  isDesktop?: boolean;
  eager?: boolean;
  customDimensions?: Partial<{
    height: number;
    width: number;
    fit: 'cover' | 'contain';
  }>;
}

const  FallBackImage = forwardRef(({ 
  src, 
  alt, 
  isUser,
  forceUpdate, 
  thumbnail, 
  isDesktop, 
  customDimensions = {width: 800, height: 450, fit: 'cover'},
  ...rest }: Props, ref: any) => {
    const placeholderImageSrc = isUser ? '/assets/images/user-default-image.png' : '/assets/images/default-image.png';

  const eager = rest.eager || rest.loading === 'eager' || rest.priority;
  //@ts-ignore
  ['priority', 'loading', 'sizes', 'fill', 'eager'].forEach(x => delete rest[x]);

  const props: any = {
    ...rest,
    fill: true,
    sizes: '100vw',
    className: twMerge(rest.className, 'absolute top-0 left-0'),
    alt,
  }

  const finalSrc = src || thumbnail || placeholderImageSrc;
  return <Image ref={ref} {...props} src={finalSrc} priority={eager} fetchPriority={eager ? 'high' : 'low'} loading={eager ? 'eager' : 'lazy'}/>;
});


export default FallBackImage;